import gql from "graphql-tag";

export const uploadImageMutation = gql`
    mutation UploadImage($uploadImageDetails: EmailImageUploadInput!) {
        communication {
            uploadEmailImage(uploadImageDetails: $uploadImageDetails) {
                url
            }
        }
    }
`;
